import React from 'react';
import PointSection from "./pointSection";

const PointAddress = ({isFrom = false, form, changeForm, companyId, changeParams, onChangeAddress, errors, isCreate = false, setFieldError}) => {

    const icon = (isFrom) => {
        switch (isFrom) {
            case true:
                return <svg width="33" height="40" viewBox="0 0 33 40" fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M16.213 40C16.213 40 32.2129 23.1215 32.2129 14.8952C32.2129 6.66884 25.0495 0 16.213 0C7.37641 0 0.212891 6.66884 0.212891 14.8951C0.212891 23.1214 16.213 40 16.213 40Z"
                        fill="#99D402"/>
                    <path
                        d="M16.2129 25C18.7134 25 20.9996 24.0822 22.753 22.5651C24.8721 20.7314 26.2129 18.0223 26.2129 15C26.2129 9.47715 21.7357 5 16.2129 5C10.69 5 6.21289 9.47715 6.21289 15C6.21289 20.5228 10.69 25 16.2129 25Z"
                        fill="white"/>
                </svg>;
            case false:
                return <svg width="33" height="40" viewBox="0 0 33 40" fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M16.213 40C16.213 40 32.2129 23.1215 32.2129 14.8952C32.2129 6.66884 25.0495 0 16.213 0C7.37641 0 0.212891 6.66884 0.212891 14.8951C0.212891 23.1214 16.213 40 16.213 40Z"
                        fill="#459EFF"/>
                    <path
                        d="M16.2129 25C18.7134 25 20.9996 24.0822 22.753 22.5651C24.8721 20.7314 26.2129 18.0223 26.2129 15C26.2129 9.47715 21.7357 5 16.2129 5C10.69 5 6.21289 9.47715 6.21289 15C6.21289 20.5228 10.69 25 16.2129 25Z"
                        fill="white"/>
                </svg>;
            default: return null;
        }
    }

    return (
        <PointSection
            icon={icon(isFrom)}
            label={isFrom ? 'Откуда' : 'Куда'}
            form={form}
            changeForm={changeForm}
            name={isFrom ? 'shipment' : 'delivery'}
            companyId={companyId}
            changeParams={changeParams}
            onChangeAddress={onChangeAddress}
            errors={errors}
            isCreate={isCreate}
            setFieldError={setFieldError}
        />
    );
};

export default PointAddress;


// WEBPACK FOOTER //
// ./App/pages/parcels/form_v3/pointAddress.jsx